var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 31,
    viewBox: "0 0 25 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 18.7813V14.9531C23.4375 13.6478 22.9189 12.3959 21.9959 11.4728C21.0729 10.5498 19.821 10.0313 18.5156 10.0313H16.3281C15.893 10.0313 15.4757 9.8584 15.168 9.55072C14.8604 9.24305 14.6875 8.82575 14.6875 8.39063V6.20313C14.6875 4.89776 14.1689 3.64586 13.2459 2.72283C12.3229 1.7998 11.071 1.28125 9.76563 1.28125H7.03125M7.03125 19.875H17.9688M7.03125 24.25H12.5M10.3125 1.28125H3.20313C2.2975 1.28125 1.5625 2.01625 1.5625 2.92188V28.0781C1.5625 28.9838 2.2975 29.7188 3.20313 29.7188H21.7969C22.7025 29.7188 23.4375 28.9838 23.4375 28.0781V14.4063C23.4375 10.9253 22.0547 7.58689 19.5933 5.12547C17.1319 2.66406 13.7935 1.28125 10.3125 1.28125Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/Vector (1).12cfb499ffdedcd2ddda2df45563144f.svg";
export { ForwardRef as ReactComponent };